<mmx-time-slot-picker-row *ngIf="!readonly">
  <ng-container icon>
    <mat-icon>calendar_today</mat-icon>
  </ng-container>

  <ng-container label>
    {{ 'time-slot-picker.custom-date.title' | translate }}
  </ng-container>

  <ng-container actions>
    <button
      mat-fab
      color="primary"
      [ngClass]="{'mat-elevation-z0': visible}"
      (click)="onToggle()"
    >
      <mat-icon *ngIf="visible">clear</mat-icon>
      <mat-icon *ngIf="visible === false">calendar_today</mat-icon>
    </button>
  </ng-container>
</mmx-time-slot-picker-row>

<ng-container *ngIf="visible">
  <div *ngIf="datePickerVisible">
    <div fxFlex fxLayout="column">
      <div class="custom-header" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-icon-button (click)="onPrevious()" [disabled]="atBeginning || canGetPrevious === false" class="more-dates-button prev-date">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span fxFlex>{{ (readonly ? 'time-slot-picker.custom-date.review-availability' : 'time-slot-picker.custom-date.select-date') | translate }}</span>
        <button mat-icon-button (click)="onNext()" class="more-dates-button next-date">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <div class="timeslots-wrap">
        <button
          *ngFor="let date of availableDates"
          (click)="onDatePicked(date)"
          class="date-button mat-elevation-z1"
          color="primary"
          [disabled]="date.availableSlotsCount === 0"
          [ngClass]="{'selected mat-elevation-z5': isDaySelected(date)}"
          fxLayout="column"
        >
          <span class="medium">{{ date.weekday }}</span>
          <span class="small">{{ date.month }}</span>
          <span class="large">{{ date.day }}</span>
          <span class="time-slot-count" fxFlex="grow">
            <ng-container *ngIf="!date.isFacilityClosed; else closedFacilityEl">
              {{ date.availableSlotsCount }}
              <br>
              {{ 'time-slot-picker.custom-date.available' | translate:{count: ''} }}
            </ng-container>
            <ng-template #closedFacilityEl>
              {{ 'time-slot-picker.custom-date.closed' | translate }}
            </ng-template>
          </span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="timesSlotPickerVisible">
    <div fxFlex fxLayout="column" fxLayoutAlign="stretch">
      <div class="custom-header">
        <button mat-flat-button (click)="onBack()" class="back-to-dates" color="accent">
          <mat-icon>chevron_left</mat-icon>
          {{ 'time-slot-picker.custom-date.all-dates' | translate }}
        </button>
        <span class="custom-header-text">
          {{ 'time-slot-picker.custom-date.select-time' | translate: {date: selectedDate?.format('dddd MMMM Do')} }}
        </span>
      </div>
      <div>
        <ng-container *ngIf="amTimeSlots.length">
          <div class="meridiem-title">{{ 'common.morning' | translate }}</div>
          <div class="timeslots-wrap times-wrap">
            <button
              *ngFor="let timeSlot of amTimeSlots"
              (click)="onTimePicked(timeSlot)"
              class="time-button mat-elevation-z1"
              [ngClass]="{'selected mat-elevation-z5': isTimeSlotSelected(timeSlot)}"
              [disabled]="readonly"
            >
              <span class="large">{{ timeSlot.format('h:mm') }}</span>
            </button>
          </div>
        </ng-container>

        <ng-container *ngIf="pmTimeSlots.length">
          <div class="meridiem-title">{{ 'common.afternoon' | translate }}</div>
          <div class="timeslots-wrap times-wrap">
            <button
              *ngFor="let timeSlot of pmTimeSlots"
              (click)="onTimePicked(timeSlot)"
              class="time-button mat-elevation-z1"
              [ngClass]="{'selected mat-elevation-z5': isTimeSlotSelected(timeSlot)}"
              [disabled]="readonly"
            >
              <span class="large">{{ timeSlot.format('h:mm') }}</span>
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
